/* rootex landing page — shared behaviour for every rootex-* section. Safe to load more than once. */
(function () {
  if (window.__rxLoaded) return;
  window.__rxLoaded = true;

  var root = document.documentElement;
  var FLAG = 'rx_discount';

  function store(k, v) { try { v === undefined ? (v = sessionStorage.getItem(k)) : sessionStorage.setItem(k, v); } catch (e) { v = null; } return v; }
  function hasCookieCode() { return /(?:^|;\s*)discount_code=/.test(document.cookie); }

  function markDiscount() { root.classList.add('rx-has-discount'); store(FLAG, '1'); }
  if (store(FLAG) === '1' || hasCookieCode()) root.classList.add('rx-has-discount');

  /* Puts the subscriber code onto the shopper's cart session, then flips every button to the discount label. */
  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .catch(function () {})
      .then(markDiscount);
  }
  window.rxApplyDiscount = applyDiscount;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* Headline variants for ad tests: add ?v=speed or ?v=barber to the ad URL. */
    var v = new URLSearchParams(location.search).get('v');
    if (v) document.querySelectorAll('[data-rx-headline-' + v + ']').forEach(function (el) {
      var t = el.getAttribute('data-rx-headline-' + v);
      if (t) el.textContent = t;
    });

    /* Add to cart without leaving the page jumpy: add, then go to cart or checkout. */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-rx-atc]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('.rx-err');
      if (btn) btn.classList.add('is-loading');
      if (err) err.textContent = '';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { location.href = form.getAttribute('data-rx-after') === 'checkout' ? '/checkout' : '/cart'; })
        .catch(function (j) {
          if (btn) btn.classList.remove('is-loading');
          if (err) err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again.';
        });
    });

    /* Native sign-up form: when Shopify confirms the sign-up, apply the code. */
    document.querySelectorAll('[data-rx-signup-success]').forEach(function (el) {
      applyDiscount(el.getAttribute('data-rx-code'));
    });

    /* Klaviyo sign-up form: Klaviyo applies the code itself, so this only flips the button labels. */
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'submit') return;
      document.querySelectorAll('[data-rx-klaviyo]').forEach(function (el) {
        var id = el.getAttribute('data-rx-klaviyo');
        if (!id || e.detail.formId === id) markDiscount();
      });
    });

    /* Founder video: play inline when the poster is tapped. */
    document.querySelectorAll('[data-rx-video]').forEach(function (box) {
      var btn = box.querySelector('.rx-play');
      var vid = box.querySelector('video');
      if (!btn || !vid) return;
      btn.addEventListener('click', function () {
        box.classList.add('is-playing');
        vid.controls = true;
        vid.play();
      });
    });

    /* Sticky add-to-cart bar on mobile: shows once every main button is off screen. */
    var bar = document.querySelector('.rx-sticky');
    var watched = document.querySelectorAll('[data-rx-cta-watch]');
    if (bar && 'IntersectionObserver' in window) {
      var seen = new Map();
      var upd = function () {
        var anyVisible = false;
        seen.forEach(function (v) { if (v) anyVisible = true; });
        bar.classList.toggle('is-on', !anyVisible && window.scrollY > 200);
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        upd();
      }, { threshold: 0.05 });
      watched.forEach(function (el) { seen.set(el, false); io.observe(el); });
      window.addEventListener('scroll', upd, { passive: true });
    }
  });
})();
